<ng-container *ngIf="!multiple">
    <span *ngIf="enumListObj.hasOwnProperty(enumValue)">{{enumListObj[enumValue]}}</span>
</ng-container>
<ng-container *ngIf="multiple">
    <span *ngFor="let itm of enumValue;let index = index">{{enumListObj[itm]}}<span
            *ngIf="index < enumValue.length - 1">,
        </span></span>
</ng-container>